function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("mask", {
  id: "gauge_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0.667,
  y: 1.5,
  width: 18,
  height: 16,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.667 1.5h18v16h-18z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 4.015a6.818 6.818 0 00-4.821 11.64l-1.072 1.07a8.334 8.334 0 1111.786 0l-1.072-1.07A6.818 6.818 0 0010 4.014zm-.444 8.058l-1.071-1.071 1.071 1.071zm4.103-4.238l-.936-.936-4.682 4.088 1.53 1.53 4.088-4.682z"
}));

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 4.015a6.818 6.818 0 00-4.821 11.64l-1.072 1.07a8.334 8.334 0 1111.786 0l-1.072-1.07A6.818 6.818 0 0010 4.014zm-.444 8.058l-1.071-1.071 1.071 1.071zm4.103-4.238l-.936-.936-4.682 4.088 1.53 1.53 4.088-4.682z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6.212 5.164l-.111-.166.111.166zm-2.511 3.06l.185.077-.185-.077zm-.388 3.94l.196-.04-.196.04zm1.866 3.49l.141.142.142-.141-.142-.142-.141.142zm-1.072 1.072l-.141.141.141.142.142-.142-.142-.141zm-2.28-4.267l-.196.04.196-.04zM2.3 7.644l-.185-.076.185.076zm3.07-3.74l.11.167-.11-.167zm9.259 0l-.111.167.11-.167zm3.069 3.74l.185-.076-.185.076zm.474 4.815l.196.04-.196-.04zm-2.28 4.267l-.142.141.142.142.141-.142-.141-.141zm-1.072-1.071l-.141-.142-.142.142.142.14.141-.14zm1.866-3.491l.196.039-.196-.04zm-.388-3.94l.185-.076-.185.076zm-2.511-3.06l.111-.166-.111.166zm-5.303 5.838l.141-.142-.23-.23-.101.31.19.062zm1.071 1.071l.19.062.038-.117-.086-.086-.142.141zm-1.071-1.071l-.19-.062-.038.116.086.087.142-.141zm1.071 1.071l-.141.141.23.23.101-.309-.19-.062zM12.723 6.9l.141-.142-.132-.132-.14.123.13.15zm.936.936l.15.132.124-.141-.133-.132-.14.141zm-5.618 3.152l-.131-.15-.161.14.15.151.142-.141zm1.53 1.53l-.141.141.151.151.14-.16-.15-.132zM6.323 5.33A6.618 6.618 0 0110 4.215v-.4a7.018 7.018 0 00-3.9 1.183l.223.333zM3.886 8.3a6.618 6.618 0 012.437-2.97l-.222-.333a7.018 7.018 0 00-2.585 3.15l.37.153zm-.377 3.823a6.618 6.618 0 01.377-3.823l-.37-.153a7.018 7.018 0 00-.4 4.055l.393-.079zm1.811 3.39a6.618 6.618 0 01-1.811-3.39l-.392.079a7.018 7.018 0 001.92 3.593l.283-.283zM4.25 16.866l1.071-1.071-.283-.283-1.071 1.071.283.283zM1.63 12.498a8.533 8.533 0 002.335 4.37l.283-.284a8.134 8.134 0 01-2.226-4.164l-.392.078zm.485-4.93a8.533 8.533 0 00-.485 4.93l.392-.078a8.133 8.133 0 01.463-4.7l-.37-.152zm3.143-3.83a8.533 8.533 0 00-3.143 3.83l.37.153A8.133 8.133 0 015.48 4.07l-.222-.333zM10 2.3c-1.688 0-3.338.5-4.74 1.438l.221.333A8.133 8.133 0 0110 2.7v-.4zm4.74 1.438A8.533 8.533 0 0010 2.3v.4c1.609 0 3.181.477 4.519 1.37l.222-.332zm3.144 3.83a8.533 8.533 0 00-3.143-3.83l-.222.333a8.133 8.133 0 012.995 3.65l.37-.153zm.485 4.93a8.534 8.534 0 00-.485-4.93l-.37.153a8.134 8.134 0 01.463 4.7l.392.077zm-2.335 4.37a8.534 8.534 0 002.335-4.37l-.392-.078a8.135 8.135 0 01-2.226 4.164l.283.283zm-1.354-1.072l1.071 1.071.283-.283-1.071-1.07-.283.282zm1.811-3.671a6.618 6.618 0 01-1.811 3.388l.283.283a7.018 7.018 0 001.92-3.593l-.392-.079zM16.114 8.3c.501 1.209.632 2.54.377 3.823l.392.079a7.018 7.018 0 00-.399-4.055l-.37.153zm-2.437-2.97a6.618 6.618 0 012.437 2.97l.37-.153a7.018 7.018 0 00-2.585-3.15l-.222.333zM10 4.215c1.309 0 2.588.388 3.677 1.116l.222-.333A7.018 7.018 0 0010 3.815v.4zm-1.657 6.928l1.072 1.071.283-.282-1.072-1.072-.283.283zm.332-.08l-.38-.123.38.124zm1.023.869L8.626 10.86l-.283.283 1.072 1.071.283-.282zm-.332.079l.38.124-.38-.124zm3.216-4.97l.936.935.282-.282-.936-.937-.283.283zm-4.41 4.096l4.682-4.087-.263-.302-4.681 4.088.263.301zm1.54 1.238l-1.53-1.53-.282.283 1.53 1.53.283-.283zm3.796-4.671l-4.087 4.681.3.263 4.089-4.681-.302-.263z",
  fill: "#fff",
  mask: "url(#gauge_svg__a)"
});

var SvgGauge = function SvgGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _ref, _ref2, _ref3);
};

export default SvgGauge;